import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import type { AgriOutSubmit } from '@/components/agricultural-materials/agri-out-note-form'
import { AgriOutNoteForm } from '@/components/agricultural-materials/agri-out-note-form'
import { useAuth } from '@/hooks/use-auth'
import { useCreateAgriOutNote } from '@/hooks/use-agri-material-lot-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new',
)({
    component: NewAgriOutNotePage,
})

function NewAgriOutNotePage() {
    const { hasPermission, arePermissionsLoaded } = useAuth()
    if (arePermissionsLoaded && !hasPermission('agri_material_lots.write')) {
        return (
            <div className="p-6 text-sm text-muted-foreground">
                {m.aml_no_permission_create()}
            </div>
        )
    }
    return <NewForm />
}

function NewForm() {
    const navigate = useNavigate()
    const create = useCreateAgriOutNote()

    const back = () =>
        navigate({ to: '/agricultural-materials/stock-out-notes' })

    const handleSubmit = async (
        value: AgriOutSubmit,
        workflow: Parameters<
            React.ComponentProps<typeof AgriOutNoteForm>['onSubmit']
        >[1],
    ) => {
        try {
            await workflow.run(
                () => create.mutateAsync(value),
                (res) => res.data?.id,
            )
            await back()
        } catch (err) {
            toast.error(
                err instanceof Error ? err.message : m.sl_new_error_create(),
            )
        }
    }

    return (
        <AgriOutNoteForm
            isPending={create.isPending}
            onSubmit={handleSubmit}
            onCancel={back}
        />
    )
}
